import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-admin-country-edit',
  templateUrl: './admin-country-edit.component.html'
})
export class AdminCountryEditComponent implements OnChanges, OnInit {
  @Input() formdata;
  @Input() types;
  @Output() doSave = new EventEmitter();
  @Output() doCancel = new EventEmitter();
  form;
  

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      id: ['', ''],
      isoCode: ['', ''],
      name: ['', ''],
      order: ['', '']
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.formdata.currentValue) {
      this.form?.patchValue(changes?.formdata.currentValue);
    }
  }

  saveCountry() {
    this.doSave.emit(this.form.value);
  }

  cancel() {
    this.doCancel.emit();
  }
}
